import { Box, Button } from '@mui/material';
import { React } from 'Imports';
import { isEncompass } from '$Utilities/integrationPlatform';

const styles = require('./DateRangeConfirmationButtons.scss') as {
    confirmationButtonContainer: string;
    confirmationButtonGeotab: string;
    confirmationButtonEncompass: string;
    applyButtonEncompass: string;
    applyButtonGeotab: string;
};

const DateRangeConfirmationButtons = (props: { handleCancel: () => void; handleApply: () => void; applyDisabled: boolean }) => {
    return (
        <Box className={styles.confirmationButtonContainer}>
            <Button
                variant={'outlined'}
                className={isEncompass ? styles.confirmationButtonEncompass : styles.confirmationButtonGeotab}
                disableRipple={true}
                disableElevation={true}
                onClick={props.handleCancel}
            >
                Close
            </Button>
            <Button
                variant={'contained'}
                className={isEncompass ? styles.applyButtonEncompass : styles.applyButtonGeotab}
                disableRipple={true}
                onClick={props.handleApply}
                disableElevation={true}
                disabled={props.applyDisabled}
            >
                Apply
            </Button>
        </Box>
    );
};

export default DateRangeConfirmationButtons;
